import React, { useState } from 'react';

export const SearchHeaderPlugin = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  return (
    <div className="mb-4 sm:flex items-end justify-end space-x-4 pl-4">
      {isFormVisible && (
        <div>
          <p className="p-2">SequenceServer Cloud can import and visualize BLAST output generated elsewhere. Please select a XML file generated by running BLAST with <i>-outfmt 5</i>.</p>

          <form action="/import" method="post" encType="multipart/form-data" className="flex space-x-4 items-center p-2 border bg-gray-100 rounded">
            <input type="hidden" name="_csrf" value={document.querySelector('meta[name="_csrf"]').content} />
            <div className="flex-grow">
              <label htmlFor="xml_file" className="sr-only">Upload XML File:</label>
              <input className="w-full" type="file" id="xml_file" name="xml_file" accept=".xml" required="required"/>
            </div>

            <button type="submit" className="flex text-xl justify-center py-1 px-4 border border-transparent rounded-md shadow-sm font-medium text-white bg-seqblue hover:bg-seqorange focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-seqorange">Upload</button>
          </form>
        </div>
      )}

      <div className="shrink-0 mt-2 sm:mt-0 px-6">
        <a href="#" onClick={toggleFormVisibility} className="text-seqblue">
          <i className="fa fa-upload mr-2">&nbsp;</i>
          Import BLAST XML
        </a>
      </div>
    </div>
  );
};
